export default __webpack_public_path__ + "static/media/park.ca871f34.png";